import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./ShiftRequestManagementFilterStatus.styles";
import {useObserver} from "mobx-react-lite";
import { shiftStatus } from "../../../../constants/shift";

export const ShiftRequestManagementFilterStatus = ({
    allKey = "all",
    showAll = true,
    hideTitle = false,
    ...props
}) => {
    const {t} = useTranslation(["shiftRequest"]);

    return useObserver(() => (
        <React.Fragment>
            {!hideTitle && <h5>{t("fields.status", {ns: "common"})}</h5>}
            <SelectField
                allowClear
                showSearch
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                data-testid="objectionStatusSelect"
                {...props}
            >
                {showAll && (
                    <SelectField.Option value={allKey} data-testid="objectionStatusSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}

                {shiftStatus.map(objectionStatus => (
                    <SelectField.Option
                        key={objectionStatus}
                        value={objectionStatus}
                        data-testid="objectionStatusSelect_option"
                    >
                        {t(`shiftDetails.status.${objectionStatus}`, {ns: "shiftRequest"})}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    ));
};
